/**
 * An active record model of a user -- this is the model we send the server to CRUD user accounts.
 */
export interface UserAr {
  userId: string;
  userName: string;
  password: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  resortLocations: number[];
  resetPassword: boolean;
  hasEmail: boolean;
  blocked: boolean;
  lastLogin: string; 
}


export const EMPTY_USER_AR: UserAr = {
  userName:       '',
  password:       '',
  firstName:      '',
  lastName:       '',
  role:           '',
  resortLocations: [],
  email:          '',
  resetPassword:  true,
  userId:         '',
  hasEmail:       false,
  blocked:        false,
  lastLogin:      '',
};
